export default __webpack_public_path__ + "static/media/aapd.79ebbc05.png";